const React = require("react");
const PropTypes = require("prop-types");
const { connect } = require("react-redux");
const {
    fetchMyInvestments: myInvestmentsRequested,
} = require("actions/brokerMyInvestments");
const { LoadingSection } = require("commonsComponents/loadingSection");
const {
    UserFundBox,
    PublicUserFundBox,
} = require("../../components/UserFundBox");
const { selectUserFund } = require("../../selectors/fundsSelectors");

class MyFundInfo extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { brokerMyInvestments, fetchMyInvestments } = this.props;
        if (!brokerMyInvestments.fetchSuccess) {
            fetchMyInvestments();
        }
    }

    render() {
        const {
            brokerMyInvestments,
            fund,
            user,
            investment,
            onlyOneFundWithSameIsin,
            location,
            isAlternativeFund,
            immFeatureFlags,
        } = this.props;

        const isPublicUser = user.get("isPublicUser", false);
        return (
            <React.Fragment>
                {brokerMyInvestments.fetchSuccess && fund && !isPublicUser && (
                    <UserFundBox
                        fund={fund}
                        investment={investment}
                        user={user}
                        location={location}
                        onlyOneFundWithSameIsin={onlyOneFundWithSameIsin}
                        isAlternativeFund={isAlternativeFund}
                        immFeatureFlags={immFeatureFlags}
                        brokerMyInvestments={brokerMyInvestments}
                    />
                )}
                {isPublicUser && (
                    <PublicUserFundBox
                        fund={fund}
                        user={user}
                        isAlternativeFund={isAlternativeFund}
                    />
                )}
                {!fund ||
                    (!brokerMyInvestments.fetchSuccess && <LoadingSection />)}
            </React.Fragment>
        );
    }
}

MyFundInfo.propTypes = {
    brokerMyInvestments: PropTypes.object.isRequired,
    fetchMyInvestments: PropTypes.func.isRequired,
    fund: PropTypes.object,
    params: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    user: PropTypes.object,
    isProspectUser: PropTypes.bool,
    onlyOneFundWithSameIsin: PropTypes.string.isRequired,
    isAlternativeFund: PropTypes.bool,
    investment: PropTypes.object,
    immFeatureFlags: PropTypes.object,
};

MyFundInfo.defaultProps = {
    fund: { customInstitutionSecurityId: 0 },
    immFeatureFlags: null,
};

const mapStateToProps = (state, props) => ({
    brokerMyInvestments: state.brokerMyInvestments.toJS(),
    investment: selectUserFund(state, props),
    user: state.profile,
});

const mapDispatchToProps = (dispatch) => ({
    fetchMyInvestments: () => dispatch(myInvestmentsRequested()),
});

module.exports = connect(mapStateToProps, mapDispatchToProps)(MyFundInfo);
